export enum EcosActionType {
  QUESTION = 'QUESTION',
  EXAMINE = 'EXAMINE',
  PERFORM = 'PERFORM',
  EXPLAIN = 'EXPLAIN',
  CARE = 'CARE',
  DIAGNOSE = 'DIAGNOSE',
}

export enum EcosSystemInstructionType {
  CONVERSATION = 'CONVERSATION',
  CORRECTION = 'CORRECTION',
}

export enum EcosVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export enum EcosMode {
  NONE = 'NONE',
  PS = 'PS',
  PSS = 'PSS',
}

export enum EcosPatientType {
  MORPHOLOGY = 'MORPHOLOGY',
  LIFESTYLE = 'LIFESTYLE',
  MEDICAL_HISTORY = 'MEDICAL_HISTORY',
  SURGERY_HISTORY = 'SURGERY_HISTORY',
  FAMILY_HISTORY = 'FAMILY_HISTORY',
  TREATMENT = 'TREATMENT',
  ALLERGIES = 'ALLERGIES',
  DISEASE_HISTORY = 'DISEASE_HISTORY',
  SYMPTOMS = 'SYMPTOMS',
  CLINICAL_EXAMINATION = 'CLINICAL_EXAMINATION',
  PARACLINICAL_EXAMINATION = 'PARACLINICAL_EXAMINATION',
  OTHER = 'OTHER',
}

export enum EcosExchangeType {
  STUDENT = 'student',
  AI = 'ai',
}
